export const DEVELOPMENT_TYPE = 'eventify';
export const STOP_API_CALLS = false;

// ======================== Baseurl related constants starts ========================
export const IS_API4 = true;

// =========== URL Constants
export const SITE_URL = IS_API4 ? 'eventify.io' : 'dev.eventify.io';
export const INSTANCE_URL = IS_API4
  ? 'https://api4.eventify.io'
  : 'https://devapi.eventify.io';
export const CDN_URL = IS_API4
  ? 'https://cdn.eventify.io/'
  : 'https://cdn-dev.eventify.io/';

// =========== Common
export const APP_API_KEY =
  'c26f1a65cc24c851ed1d2ebb69eb2d64686823891ca0408dae59fb58b6844293';
export const PROJECT_URI = 'eventify.io';
export const SCRIPT_URI_ADDON = `/api/v2`;
export const TABLE_URI_ADDON = `${SCRIPT_URI_ADDON}/eventify/_table`;
export const FILES_URL = `${SCRIPT_URI_ADDON}/files`;
export const VIDEO_FILES_URL = `${SCRIPT_URI_ADDON}/getvideo`;

// Scan Generate Url
export const SCAN_GENERATE_URL = `###BASE_URL###/qrcode.php?s=qr&d=###LINK_URL###&sf=10&ms=r&md=1&wq=0&h=500&w=500`;
// Invoice Url
export const COMMON_INVOICE_URL = `${CDN_URL}eventify/###EVENTID###/invoice/order-###ORDER_ID###.pdf?download=true`;
// Order URL
export const COMMON_ORDER_URL =
  '###BASE_URL###/tickets/ticketorder/###ORDER_ID###';
// ENC download URL
export const ENC_FILES_URL = `${INSTANCE_URL}${SCRIPT_URI_ADDON}/download_enc/###PATH###?api_key=${APP_API_KEY}&session_token=###TOKEN###`;
// --- Redirecting URLS
// Analytics
export const ANALYTICS_URL = `###BASE_URL###/stats?id=##TYPEID##&type=##TYPE##&sessiontoken=##SESSION_TOKEN##`;
// SSO Auth
export const SSO_AUTH_URL = `sso/authorize?eventid=###EVENTID###&api_key=${APP_API_KEY}`;
// ZoomSDK URL
export const ZOOM_SDK_URL = `###BASE_URL###/z${
  IS_API4 ? '2' : ''
}?userid=###APPUSER_ID###&email=###USER_EMAIL###&name=###USER_NAME###&sessionid=###SESSION_ID###&meetingnumber=###MEETING_NUMBER###&meetinglink=###JOIN_LINK###&token=###SESSION_TOKEN###`;
// Widget URL
export const WIDGET_URL = `###BASE_URL###/widget${
  IS_API4 ? '2' : ''
}/###SECTION###?header=false&embeded=true&sessioncolor=true&bgcolor=###BG_COLOR###&fontcolor=###FONT_COLOR###&lang=###LANG_KEY###`;
// Terms URL
export const TNC_URL = `###BASE_URL###/t${IS_API4 ? '2' : ''}/terms-conditions`;
// Privacy URL
export const PRIVACY_URL = `###BASE_URL###/t${
  IS_API4 ? '2' : ''
}/privacy-policy`;
// Lve Qna Url
export const LIVEQA_URL = `###BASE_URL###/o${
  IS_API4 ? '2' : ''
}/#/live-qa/###SESSIONID###`;
// public_with_ticket
export const PUBLIC_WITH_TICKET_URL = `###BASE_URL###${
  IS_API4 ? '/t2' : '/t'
}/tickets`;
// public_with_reg url
export const PUBLIC_WITH_REG_URL = ` ###BASE_URL###${
  IS_API4 ? '/t2' : '/t'
}/register`;
// redirect url
export const TICKET_REDIRECT_URL = `###BSE_URL###${
  IS_API4 ? '/t2' : '/t'
}/tickets###ASSOCIATE_TICKETS###`;

export const INITIAL_APP_THEME = 'light';
export const INITIAL_APP_LANGUAGE = 'en';

export const LOCAL_FILES_URL = 'src/assets/';
export const LOCAL_FILES_IMG = `${LOCAL_FILES_URL}img/`;

// =========== Google Maps
// export const GOOGLE_MAP_KEY = 'AIzaSyCFUITnYyLeEW_nmAxZgYbMpfKQwLAlLMU'; // Test
export const GOOGLE_MAP_KEY = 'AIzaSyD43ZsO29SstAuHzztQzx_EGCY1t50SPF8'; // Live
export const GOOGLE_MAP_URL_LOCATION = 'https://www.google.com/maps/search/';
export const GOOGLE_MAP_URL_DIRECTION =
  'https://www.google.com/maps/dir/current+location/';
// ========================  Baseurl related constants ends  ========================

export const LABEL_POSITION_TOP = 'TOP';
export const LABEL_POSITION_LEFT = 'LEFT';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_FORMAT_WITH_SECOND = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT_FNS = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT_FNS = 'yyyy-MM-dd HH:mm';
export const DATE_TIME_FORMAT_WITH_SECOND_FNS = 'yyyy-MM-dd HH:mm:ss';

export const LOCAL_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const LOCAL_TIMEZONE_LOCALE = Intl.DateTimeFormat().resolvedOptions()
  .locale;

export const AXIOS_NO_INTERNET_MESSAGE = 'Network Error';

export const THUMB_20 = 'thumb20_';

export const INTERVAL_1 = 1000;
export const INTERVAL_3 = 3 * 1000;
export const INTERVAL_5 = 5 * 1000;
export const INTERVAL_10 = 10 * 1000;
export const INTERVAL_MIN_1 = INTERVAL_10 * 6;

export const OFFSET_LIMIT_10 = 10;
export const OFFSET_LIMIT_20 = 20;
export const OFFSET_LIMIT_50 = 50;
export const OFFSET_LIMIT_100 = 100;
export const OFFSET_LIMIT_500 = 500;
export const OFFSET_LIMIT_1000 = 1000;

export const SESSION_NO_TRACK = '##NOTRACK##';

export const PORTAL_LOCALSTORAGE_ACCESS_KEY = {
  state: 'webportal',
  globalsearch: 'global-search',
  community: 'community',
  persist: 'persist:temp',
  schedule: 'schedule',
  flashPopups: 'flash-popups',
  netConnection: 'net-connection'
};

export const FILE_TYPES = {
  image: ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'svg'],
  video: [
    'm4v',
    'avi',
    'mpg',
    'mp4',
    'mov',
    'flv',
    'mkv',
    'wmv',
    'webm',
    'mpeg',
    'mpeg-4'
  ],
  audio: ['mp3', 'wav', 'ogg'],
  files: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'tar', 'rar']
};

export const EMOJI_RATING_OPTIONS = ['😍', '🙂', '😐', '😒', '😖'];

export const LEAD_FORM_AUDIO_PREFIX = 'LFAudio_';

export const INTERACTIVE_MAP_CONVERSION_UNIT = 37.7;

export const DATEPICKER_START_YEAR = 1990;
